import React from 'react';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { BodyRegular, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { CarParkBooking } from "@features/desks/services/OfficeCapacityService";
import styled from "styled-components";
import { Period } from '@features/whereabouts/models/movements.models';

export function CarParkBookingRow(props: Props) {
  const {booking} = props;
  return (
    <>
      <Row>
        <UserAvatarAndName firstName={booking.firstName}
                           lastName={booking.lastName}
                           colour={'darkBlue'}
                           hideName={true} />
        <Column>
          <BodyRegular>{`${booking.firstName} ${booking.lastName}`}</BodyRegular>
          <BodyVerySmall>{booking.registration}</BodyVerySmall>
        </Column>

        {booking.period && booking.period !== Period.AllDay && <BodyRegular className={"period"} colour={Colours.blue}>{booking.period}</BodyRegular>}
      </Row>
    </>
  )
}

interface Props {
  booking: CarParkBooking
}

const Row = styled.div`
  display: flex;
  align-content: center;
  border-top: 1px solid ${Colours.lightGrey};
  margin-top: 20px;
  padding-top: 20px;
  .period {
    align-self: center;
    margin-left: auto;
  }
  .userAvatarAndName__avatar {
    align-self: center;
    margin-right: 16px;
  }
  &:last-child {
    margin-bottom: 20px;
  }
`
